import React from "react";
import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Concerts from "@/pages/Concerts";
import ConcertDetail from "@/pages/ConcertDetail";
import ConcertLive from "@/pages/ConcertLive";
import ArtistDashboard from "@/pages/ArtistDashboard";
import AssetStudio from "@/pages/AssetStudio";
import AISupport from "@/pages/AISupport";
import Contract from "@/pages/Contract";
import AuthCallback from "@/pages/AuthCallback";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AdminDashboard from "@/pages/AdminDashboard";
import InstallApp from "@/pages/InstallApp";
import InstallPrompt from "@/components/InstallPrompt";

const Protected = ({ children, role }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen bg-black flex items-center justify-center text-white">Chargement...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) return <Navigate to="/concerts" replace />;
  return children;
};

const AppRoutes = () => {
  const location = useLocation();
  // Detect OAuth callback synchronously during render to avoid race conditions
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/concerts" element={<Concerts />} />
      <Route path="/concert/:id" element={<ConcertDetail />} />
      <Route path="/live/:id" element={<Protected><ConcertLive /></Protected>} />
      <Route path="/dashboard" element={<Protected role="artist"><ArtistDashboard /></Protected>} />
      <Route path="/contract" element={<Protected role="artist"><Contract /></Protected>} />
      <Route path="/admin" element={<Protected role="admin"><AdminDashboard /></Protected>} />
      <Route path="/install" element={<InstallApp />} />
      <Route path="/studio" element={<Protected><AssetStudio /></Protected>} />
      <Route path="/support" element={<Protected><AISupport /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster theme="dark" position="top-right" richColors />
        <AppRoutes />
        <InstallPrompt />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
